import { AuthUser } from '@/models/AuthModels';

export type State = {
  authUser: AuthUser | null;
};

export const state: State = {
  authUser: sessionStorage.getItem('authUser') != null ? JSON.parse(sessionStorage.authUser) : null,
};
